import { Button, Typography } from '@repo/ui';
import { useState } from 'react';

import { LINKS } from 'assets/constants';

import styles from './AIMessageFeedbackForm.module.css';

interface AIMessageFeedbackFormProps {
  onSubmit: (feedback: string) => void;
  onCancel?: () => void;
  isSubmitted: boolean;
}

export const AIMessageFeedbackForm = ({
  onSubmit,
  onCancel,
  isSubmitted,
}: AIMessageFeedbackFormProps) => {
  const [feedbackText, setFeedbackText] = useState('');

  const handleSubmit = () => {
    if (feedbackText.trim()) {
      onSubmit(feedbackText.trim());
    }
  };

  if (isSubmitted) {
    return (
      <div className={styles.formContainer}>
        <Typography variant='caption' className={styles.thankYouMessage}>
          Thank you for helping us improve this feature!
        </Typography>
      </div>
    );
  }

  return (
    <div className={styles.formContainer}>
      <textarea
        className={styles.textarea}
        placeholder='Provide details about your feedback'
        value={feedbackText}
        onChange={e => setFeedbackText(e.target.value)}
        rows={3}
      />
      <div className={styles.footer}>
        <Typography variant='caption' className={styles.scheduleText}>
          Prefer to chat with the Product Team?{' '}
          <a
            href={LINKS.productFeedbackCalendly}
            target='_blank'
            rel='noopener noreferrer'
            className={styles.scheduleLink}
          >
            Schedule a call
          </a>
        </Typography>
        <Button
          variant='solid'
          size='small'
          color='purple'
          label='Submit'
          onClick={handleSubmit}
          disabled={!feedbackText.trim()}
        />
      </div>
    </div>
  );
};
